import React from "react";

interface CheckMarkProps {
    size?: number;
    color?: string;
    className?: string;
}

export default function ChecklistIcon({
    size = 20,
    color = "#79808A",
    className,
}: CheckMarkProps) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2.40039C14.1976 2.40039 17.5996 5.80266 17.5996 10C17.5996 14.1976 14.1976 17.5996 10 17.5996C5.80266 17.5996 2.40039 14.1976 2.40039 10C2.40039 5.80266 5.80266 2.40039 10 2.40039ZM10 3.53711C6.43671 3.53711 3.53711 6.43671 3.53711 10C3.53713 13.5636 6.43702 16.4775 10 16.4775C13.563 16.4775 16.4629 13.5636 16.4629 10C16.4629 6.43673 13.5633 3.53711 10 3.53711ZM12.9229 7.18457C13.1452 6.96288 13.5053 6.96265 13.7275 7.18457V7.18555C13.9213 7.38012 13.9455 7.67977 13.7998 7.90039L13.7275 7.98926L9.05957 12.6846C9.04267 12.7082 9.02473 12.7331 9.00195 12.7559C8.77967 12.9776 8.41938 12.9777 8.19727 12.7559L5.87695 10.4355C5.65527 10.2136 5.65538 9.85388 5.87695 9.63184H5.87793C6.10023 9.40982 6.45952 9.40971 6.68164 9.63184L8.5918 11.542L12.9219 7.18555L12.9229 7.18457Z" fill="#79808A" stroke="#79808A" stroke-width="0.2" />
        </svg>

    );
}
